<template>
    <form class="profile__information-form" @submit.prevent="formController">
        <input type="hidden" id="id" name="id" v-model="model.id">
        <div class="input-box">
            <label>Nombre</label>
            <input type="text" id="name" name="name" v-model="model.name">
        </div>
        <div class="input-box">
            <label>Apellido</label>
            <input type="text" id="last_name" name="last_name" v-model="model.last_name">
        </div>
        <div class="input-box">
            <label>Email</label>
            <input type="email" id="email" name="email" v-model="model.email">
        </div>
        <div class="input-box">
            <label>Teléfono</label>
            <input type="tel" id="phone" name="phone" v-model="model.phone">
        </div>
 
        <template v-if="model.type === 1 ">
            <div class="input-box">
                <label>Nombre Empresa</label>
                <input type="tel" id="company_name" name="company_name" v-model="model.company_name">
            </div>
            <div class="input-box" >
                <label>RUC</label>
                <input type="tel" id="ruc" name="ruc" v-model="model.ruc">
            </div>
        </template>
        <h4>¿Desea cambiar de contraseña?</h4>
        <div class="input-box">
            <label>Nueva contraseña</label>
            <input type="password" id="password" name="password" v-model="model.password">
        </div>
        <div class="input-box">
            <label>Confirmar nueva contraseña</label>
            <input type="password" id="password_confirmation" name="password_confirmation" v-model="model.password_confirmation">
        </div>
        <div class="input-box">
            <button class="btn btn--green">Guardar cambios</button>
        </div>
        <div class="logout-box">
            <a :href="url_sign_out" class="btn btn--outline-red">Cerrar sesión</a>
        </div>
    </form>
</template>

<script>
import { onMounted, reactive, ref } from 'vue';
import { customAlert } from "@general/js/utils/swalMessages";
import axios from 'axios';

export default {
    props: {
        user_id: {
            type: String,
            default: '',
        },
        url_detail: {
            type: String,
            default: '',
        },
        url_store: {
            type: String,
            default: ''
        },
        url_sign_out: {
            type: String,
            default: ''
        },
    },
    setup(props) {
        const model = reactive({
            name: '',
            last_name: '',
            email: '',
            phone: '',
            password: '',
            company_name:'',
             type:'',
              ruc:'',
            password_confirmation: ''
        });

        const getDetail = async () => {
            try {
                const { data } = await axios.request({
                    url: props.url_detail,
                    method: 'POST',
                    data: props.user_id
                });

                model.id = data.id;
                model.name = data.name;
                model.last_name = data.last_name;
                model.email = data.email;
                          model.company_name = data.company_name;
                                    model.ruc = data.ruc;
                                              model.type = data.type;
                model.phone = data.phone;
            } catch (error) {
                console.error(error);
            }
        }

        const formController = async () => {
            try {
                const { data } = await axios.request({
                    url: props.url_store,
                    method: 'PUT',
                    data: model
                });

                if ( data.type == 1 ) {
                    getDetail();

                    model.password = '';
                    model.password_confirmation = '';
                }

                customAlert(data);
            } catch (error) {
                console.error(error);
            }
        }

        onMounted(() => {
            getDetail();
        });

        return {
            model,
            getDetail,
            formController,
        }
    }
}
</script>
